import React, {PropTypes, Component} from 'react';
import {Link} from 'react-router';
import s from './pager.scss';
class Pager extends Component {
  static propTypes = {
    numPages: PropTypes.number.isRequired,
    relPath: PropTypes.string.isRequired,
    current: PropTypes.number.isRequired,
    visiblePages: PropTypes.string.isRequired
  }

  generateLink(index, relPath) {
    const rel = relPath === '' ? '' : `/${relPath}`;
    return index <= 1 ? `/${relPath}` : `${rel}/page/${index}`;
  }

  render() {
    let {numPages, visiblePages, current, relPath} = this.props;
    const lastPage = numPages;
    visiblePages = parseInt(visiblePages, 10);
    numPages = [];
    for (let i = 0; i < lastPage; i++) {
      numPages.push(i);
    }
    const midPoint = Math.floor(visiblePages / 2);
    let firstPageToDisplay = current - midPoint > 0 ? current - midPoint - 1 : 0;
    let lastPageToDisplay = current + midPoint < numPages.length + 1 ? current + midPoint : numPages.length + 1;
    if (lastPageToDisplay < visiblePages) {
      lastPageToDisplay = lastPageToDisplay + 1 < numPages.length + 1 ? lastPageToDisplay + 1 : numPages.length + 1;
    }
    if (numPages.length - firstPageToDisplay < visiblePages) {
      firstPageToDisplay = firstPageToDisplay - 1 > 0 ? firstPageToDisplay - 1 : 0;
    }
    const range = numPages.length > visiblePages ? numPages.slice(firstPageToDisplay, lastPageToDisplay) : numPages;
    if (lastPage <= 1) {
      return <span/>;
    }
    return (
      <nav className={s.pagination}>
        <ul>
          <li>
            <Link data-hook="pager-goto-start" to={this.generateLink(1, relPath)} data-isdisabled={current <= 1 ? 'true' : 'false'}>
              <svg role="button" version="1.1" viewBox="-301.3 8.3 12.2 9" x="0" y="0" xmlSpace="preserve" className={s.prev}>
                <polygon className={s.st0} points="-293.5 17.3 -294.1 16.6 -290.4 12.8 -294.1 8.9 -293.5 8.3 -289.1 12.8"/>
                <polygon className={s.st0} points="-300.7 17.3 -301.3 16.6 -297.6 12.8 -301.3 8.9 -300.7 8.3 -296.3 12.8"/>
              </svg>
            </Link>
          </li>
          <li>
            <Link data-hook="pager-goto-prev" to={this.generateLink(current - 1, relPath)} data-isdisabled={current <= 1 ? 'true' : 'false'}>
              <svg role="button" version="1.1" viewBox="-304 6.5 7 14" x="0" y="0" xmlSpace="preserve" className={s.prev}>
                <polygon className={s.st0} points="-303.3 20.5 -304 19.9 -298.3 13.5 -304 7.2 -303.3 6.5 -297 13.5"/>
              </svg>
            </Link>
          </li>
          {range.map(index => {
            const pageIndex = index + 1;
            return current === pageIndex ? <li data-hook="pager-goto-page-num" key={index}>{pageIndex}</li> : <li key={index}><Link data-hook="pager-goto-page-num" to={this.generateLink(pageIndex, relPath)} key={index}>{pageIndex}</Link></li>;
          })}
          {
            lastPageToDisplay < lastPage - 1 ? <li data-hook="pager-continues-delimiter">...</li> : []
          }
          {
            lastPageToDisplay < lastPage ? <li><Link data-hook="pager-goto-last-by-num" to={this.generateLink(lastPage, relPath)} >{lastPage}</Link></li> : []
          }
          <li>
            <Link data-hook="pager-goto-next" to={this.generateLink(current + 1, relPath)} data-isdisabled={current >= lastPage ? 'true' : 'false'}>
              <svg role="button" version="1.1" viewBox="-304 6.5 7 14" x="0" y="0" xmlSpace="preserve">
                <polygon className={s.st0} points="-303.3 20.5 -304 19.9 -298.3 13.5 -304 7.2 -303.3 6.5 -297 13.5"/>
              </svg>
            </Link>
          </li>
          <li>
            <Link data-hook="pager-goto-last" to={this.generateLink(lastPage, relPath)} data-isdisabled={current >= lastPage ? 'true' : 'false'}>
              <svg role="button" version="1.1" viewBox="-301.3 8.3 12.2 9" x="0" y="0" xmlSpace="preserve">
                <polygon className={s.st0} points="-293.5 17.3 -294.1 16.6 -290.4 12.8 -294.1 8.9 -293.5 8.3 -289.1 12.8"/>
                <polygon className={s.st0} points="-300.7 17.3 -301.3 16.6 -297.6 12.8 -301.3 8.9 -300.7 8.3 -296.3 12.8"/>
              </svg>
            </Link>
          </li>

        </ul>
      </nav>
    );
  }
}

export default Pager;



// WEBPACK FOOTER //
// ./components/partial/Pager/Pager.js